import React, {useState, useEffect} from 'react'
import {fieldNameConverter} from '../../validators'
import {Select, Radio, Checkbox} from 'antd'
import {auth} from '../../Auth'
import {connect} from 'react-redux'
import useSetInspector from './useSetInspector'
import {setField} from '../action_creators'
import {store} from '../utilities'

const mapStateToProps = (state) => ({fields: state.fields })

const InspectionInformation = ({fields, allowCreateProject}) => {

  if (!fields) fields = {}
  
  const {inspector, inspectorType = null } = fields
  const [fus, set] = useSetInspector() // this  will update 
  
  return (
    <div className="flex-column align-start padding-2 margin-bottom-1" style={{background: `#F4F6F8`}}>
      <h3>Inspector Information</h3>
      <div className="full-width flex-column align-start">
        {fields.projectType && fields.projectType.noSchedule && (
          <h3 className="bold padding-1">Do not schedule an intake for the the selected project type</h3>
        )}
        {(fields.organization || {}).name === auth.sunkaizenUser.organization.name && (
          <div className="full-width">
            <Radio.Group
              disabled={allowCreateProject || (fields.organization || {}).name !== auth.sunkaizenUser.organization.name}
              className="padding-1"
              onChange={(e) => {
                //setCategory(e.target.value);
                // Clear the inspector dropdown on radio change
                store.dispatch(setField('inspector', null));
                store.dispatch(setField('inspectorType', e.target.value));
              }}
              style={{paddingLeft: 0, paddingTop: 0}}
              value={inspectorType}
            >
              <Radio value="internal">Internal</Radio>
              <Radio value="third-party">Third Party</Radio>
              <Radio value="client">Self-Submit</Radio>
              <button disabled={!inspectorType} style={{ marginLeft: 10 }} onClick={()=>{ 
                store.dispatch(setField('inspectorType', null))
                store.dispatch(setField('inspector', null))
                }}>Clear</button>
            </Radio.Group>
            <Select
              disabled={allowCreateProject || (fields.projectType && fields.projectType.noSchedule) || !inspectorType}
              onChange={(e) => set(e)}
              value={inspector ? inspector.name : null}
              size="large"
              className="full-width"
              placeholder={fieldNameConverter[`inspector`]}
              data-cy="inspector"
            >
              {fus
                .sort((a, b) => { 
                  const titleA = (a.name ?? "").toLowerCase();
                  const titleB = (b.name ?? "").toLowerCase();
                  if (titleA < titleB) return -1;
                  if (titleA > titleB) return 1;
                  return 0;
                })
                .map((user) => (
                  <Select.Option key={user.id} value={user.id}>
                    {user.name}
                  </Select.Option>
                ))}
            </Select>
          </div>
        )}
        <hr />
        <Checkbox
          checked={fields.restrict_schedule}
          onChange={(e) => {
            //console.info('checkbox changed', e)
            store.dispatch(setField('restrict_schedule', e.target.checked))
          }}
          disabled={allowCreateProject}
        >
          Restrict Scheduling on Inspector Availability
        </Checkbox>
      </div>
    </div>
  )
}

const WrappedInspectionInformation = connect(mapStateToProps)(InspectionInformation)
export default WrappedInspectionInformation
